import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Box,
  Divider,
} from '@mui/material';
import { Department } from '../../types';

interface DepartmentListProps {
  departments: Map<string, Department>;
  selectedDepartments: string[];
  onDepartmentSelect: (deptName: string) => void;
}

export const DepartmentList: React.FC<DepartmentListProps> = ({
  departments,
  selectedDepartments,
  onDepartmentSelect,
}) => {
  return (
    <Paper elevation={3} sx={{ height: '56vh', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" sx={{ p: 2, pb: 1 }}>
        Departments
      </Typography>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <List dense disablePadding>
          {Array.from(departments.entries()).map(([deptName, dept], index, array) => (
            <React.Fragment key={deptName}>
              <ListItem disablePadding dense>
                <ListItemButton 
                  onClick={() => onDepartmentSelect(deptName)}
                  dense
                  sx={{ py: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Checkbox
                      edge="start"
                      checked={selectedDepartments.includes(deptName)}
                      tabIndex={-1}
                      disableRipple
                      size="small"
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {deptName}
                        </Typography>
                        <Typography
                          component="span"
                          variant="caption"
                          color="text.secondary"
                        >
                          ({dept.employeeCount})
                        </Typography>
                      </Box>
                    }
                  />
                </ListItemButton>
              </ListItem>
              {index < array.length - 1 && (
                <Divider variant="middle" component="li" light />
              )}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

export default DepartmentList;
